import agricultureIcon from "../assets/images/agriculture.svg";
import arrowDownIcon from "../assets/images/arrow-down.svg";
import arrowIcon from "../assets/images/arrow-right-bold.svg";
import alarmIcon from "../assets/images/ax-alarm.svg";
import archeryIcon from "../assets/images/ax-archery.svg";
import arrowBentIcon from "../assets/images/ax-arrow-bent.svg";
import brokenPipeIcon from "../assets/images/ax-broken-pipe.svg";
import buildingIcon from "../assets/images/ax-building.svg";
import constructionIndustryIcon from "../assets/images/ax-crane.svg";
import findPestIcon from "../assets/images/ax-find-pest.svg";
import hotelRestaurantIcon1 from "../assets/images/ax-hotel-restaurant.svg";
import industryIcon2 from "../assets/images/ax-industry-2.svg";
import moneyIcon from "../assets/images/ax-money.svg";
import monitorIcon from "../assets/images/ax-monitor.svg";
import municipalitiesIcon from "../assets/images/ax-municipalities.svg";
import thumbUpIcon from "../assets/images/ax-thumb-up.svg";
import birdIcon from "../assets/images/bird.svg";
import building2Icon from "../assets/images/building.svg";
import chemicalsIcon from "../assets/images/chemicals.svg";
import chemicals2Icon from "../assets/images/chemicals2.svg";
import cloudIcon from "../assets/images/cloud.svg";
import eVehicleIcon from "../assets/images/evehicle.svg";
import extinguisherIcon from "../assets/images/extinguisher.svg";
import findMouseIcon from "../assets/images/find-mouse.svg";
import fingerprintIcon from "../assets/images/fingerprint.svg";
import foodIcon from "../assets/images/food.svg";
import foodIcon2 from "../assets/images/food_2.svg";
import growthIcon from "../assets/images/growth.svg";
import handshakeIcon from "../assets/images/handshake.svg";
import heartIcon from "../assets/images/heart.svg";
import hotelRestaurantIcon2 from "../assets/images/hotel-restaurant_2.svg";
import houseSearchIcon from "../assets/images/house-search.svg";
import industryIcon1 from "../assets/images/industry.svg";
import leafIcon from "../assets/images/leaf.svg";
import lightbulbIcon from "../assets/images/lightbulb.svg";
import listIcon from "../assets/images/list.svg";
import mouseBugIcon from "../assets/images/mouse-bug.svg";
import peopleIcon from "../assets/images/people.svg";
import radarIcon from "../assets/images/radar.svg";
import recycleIcon from "../assets/images/recycle.svg";
import reviewStarEmpty from "../assets/images/reviewStarEmpty.svg";
import reviewStarFilled from "../assets/images/reviewStarFilled.svg";
import shieldIcon from "../assets/images/shield.svg";
import tabletScanIcon from "../assets/images/tablet-scan.svg";
import tedGustafLogo from "../assets/images/ted-gustaf-logo.svg";
import waterDropIcon from "../assets/images/water-drop.svg";
import windowsIcon from "../assets/images/windows.svg";

export const iconsList = {
  alarmIcon: alarmIcon.url,
  agricultureIcon: agricultureIcon.url,
  archeryIcon: archeryIcon.url,
  arrowBentIcon: arrowBentIcon.url,
  arrowIcon: arrowIcon.url,
  birdIcon: birdIcon.url,
  buildingIcon: buildingIcon.url,
  building2Icon: building2Icon.url,
  brokenPipeIcon: brokenPipeIcon.url,
  constructionIndustryIcon: constructionIndustryIcon.url,
  chemicalsIcon: chemicalsIcon.url,
  chemicals2Icon: chemicals2Icon.url,
  chevronIcon: arrowDownIcon.url,
  cloudIcon: cloudIcon.url,
  eVehicleIcon: eVehicleIcon.url,
  extinguisherIcon: extinguisherIcon.url,
  findMouseIcon: findMouseIcon.url,
  findPestIcon: findPestIcon.url,
  fingerprintIcon: fingerprintIcon.url,
  foodIcon: foodIcon.url,
  foodIcon2: foodIcon2.url,
  peopleIcon: peopleIcon.url,
  growthIcon: growthIcon.url,
  handshakeIcon: handshakeIcon.url,
  heartIcon: heartIcon.url,
  hotelRestaurantIcon1: hotelRestaurantIcon1.url,
  hotelRestaurantIcon2: hotelRestaurantIcon2.url,
  houseSearchIcon: houseSearchIcon.url,
  industryIcon1: industryIcon1.url,
  industryIcon2: industryIcon2.url,
  leafIcon: leafIcon.url,
  lightbulbIcon: lightbulbIcon.url,
  listIcon: listIcon.url,
  municipalitiesIcon: municipalitiesIcon.url,
  moneyIcon: moneyIcon.url,
  monitorIcon: monitorIcon.url,
  mouseBugIcon: mouseBugIcon.url,
  radarIcon: radarIcon.url,
  recycleIcon: recycleIcon.url,
  shieldIcon: shieldIcon.url,
  tabletScanIcon: tabletScanIcon.url,
  thumbUpIcon: thumbUpIcon.url,
  waterDropIcon: waterDropIcon.url,
  windowsIcon: windowsIcon.url,
  reviewStarFilled: reviewStarFilled.url,
  reviewStarEmpty: reviewStarEmpty.url,
  tedGustafLogo: tedGustafLogo.url
};
